'use client';

import { logger } from '@dealerportal/core';
import { useClientContext } from '@dealerportal/react-helpers';
import { usePathname, useSearchParams } from 'next/navigation';
import { useEffect, useRef } from 'react';

export function AnalyticsListener() {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const ctx = useClientContext();

  const prevPathRef = useRef<string | null>(null);

  useEffect(() => {
    const current = pathname + searchParams.toString();
    if (prevPathRef.current === current) return;
    const isFirstLoad = prevPathRef.current === null;
    prevPathRef.current = current;
    if (isFirstLoad) return;

    window.analytics?.page?.(
      {
        retailer: {
          name: ctx.clientName,
          universalRetailerId: ctx.universalRetailerId,
        },
      },
      window.analytics?._defaultContext
    );
    logger
      .withMetadata({
        pathname,
      })
      .info('Tracked page view');
  }, [pathname, searchParams, ctx.clientName, ctx.universalRetailerId]);

  return null;
}
